import type { DocumentNode } from 'graphql';

const getDocumentKey = (query: DocumentNode): string =>
  (query.definitions[0] as any).name.value;

export default getDocumentKey;
